(function () {
  $(window).load(function () {
    
    // Carousel Items
    $('.carousel-main').flickity({
      pageDots: false,
      contain: true,
      cellAlign: 'left',
      wrapAround: true,
      adaptiveHeight: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 75, y2: 50,
        x3: 25
      }
    });
    
    // Carousel Hero
    $('.carousel-hero').flickity({
      pageDots: false,
      contain: true,
      cellAlign: 'left',
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      adaptiveHeight: true,
      autoPlay: 4000,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 75, y2: 50,
        x3: 25
      }
    });

    // Testimonial slider
    $('.testimonial-slider').flickity({
      pageDots: true,
      contain: true,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      adaptiveHeight: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 75, y2: 50,
        x3: 25
      }
    });

    // Main nav toggle content
    $('.has-dropdown-links > a ').click(function(e){
      e.preventDefault();
      $(this).siblings().toggleClass('active');
    });
    $('.header-search-icon').click(function(e){
      e.preventDefault();
      $('.floating-search-bar').toggleClass('active');
    });

    $('.youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });

    $('.watch_video').magnificPopup({
      disableOn: 700,
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      callbacks: {
        open: function() {
        // Play video on open:
        $(this.content).find('video')[0].play();
        },
        close: function() {
        // Reset video on close:
        $(this.content).find('video')[0].load();
        }
      }
    });


    https://cdn.shopify.com/videos/c/o/v/7f8e5873572f44d3b9732fe6d3eda9af.mp4?autoplay=1

    
    // $('.pdf-popup').magnificPopup({
    //   type: 'iframe'
    // });
    // if (window.location.href.indexOf('?customer_posted=true#magnifile_form') > 0) {
    //   $('#pdf_popup').trigger('click');
    // }

    if ($(window).width() < 701) {
      $('.menu-accordion > h4').click(function(){
       $(this).toggleClass('active').siblings().slideToggle();
      });
    }


  });
  
})();


// Simple image slider 
var element = document.querySelector('.image-slider');
if (typeof(element) != 'undefined' && element != null) {
  var current = 0,
      slides = document.getElementsByClassName("image-slide");
  var slideSpeed = parseInt(element.dataset.speed);

  setInterval(function() {
  for (var i = 0; i < slides.length; i++) {
      slides[i].style.opacity = 0;
      slides[i].style.height = 0;
  }
  current = (current != slides.length - 1) ? current + 1 : 0;
  slides[current].style.opacity = 1;
  slides[current].style.height = 'auto';
  }, slideSpeed);        
}

// Simple image slider 
var pf_element = document.querySelector('.pf-slider');
if (typeof(pf_element) != 'undefined' && pf_element != null) {
  var pf_current = 0,
      pf_slides = document.getElementsByClassName("pf-slide");
  var pf_slideSpeed = parseInt(pf_element.dataset.speed);

  setInterval(function() {
  for (var i = 0; i < pf_slides.length; i++) {
      pf_slides[i].style.opacity = 0;
      pf_slides[i].style.height = 0;
  }
  pf_current = (pf_current != pf_slides.length - 1) ? pf_current + 1 : 0;
  pf_slides[current].style.opacity = 1;
  pf_slides[current].style.height = 'auto';
  }, slideSpeed);        
}

jQuery(document).ready(function($) { 
	$('.collection .site-nav .has-dropdown  > a').wrap('<div class="semgeeks-has-dropdown-wrap"></div>');
	$('.collection .site-nav .has-dropdown  .semgeeks-has-dropdown-wrap').append('<span class="semgeeks-menu-dropdown-icon"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>');
    $('.collection .site-nav li li li.active').parent().parent().parent().closest('li').toggleClass('semgeeks-dropdown-open');
    $('.collection .site-nav li.active').parent().closest('li').toggleClass('semgeeks-dropdown-open');
    $('.collection .site-nav li.active').closest('li').toggleClass('semgeeks-dropdown-open');
	$('.collection .site-nav .has-dropdown  .semgeeks-menu-dropdown-icon').click(function(e) {
		$(this).parent().closest('li').not(this).toggleClass('semgeeks-dropdown-open');
		$(this).parent().closest('li').not(this).siblings().removeClass('semgeeks-dropdown-open');
		$(this).parent().closest('li').not(this).find('.semgeeks-menu-dropdown-icon:first').toggleClass('semgeeks-menu-dropdown-icon-flipped');
		$(this).parent().closest('li').not(this).siblings().find('.semgeeks-menu-dropdown-icon:first').removeClass('semgeeks-menu-dropdown-icon-flipped');
	});
});


